import {
  FeedbackMediaType,
  useWhatsNewModal,
  WhatsNewModal,
} from "@amzn/stencil-react-components/dist/submodules/whats-new";
import { COOKIE_NAMES, getCookie, setCookie } from "common/helpers/cookie-utils";
import React, { useEffect, useState } from "react";
import { FC } from "react";

import AiForMefeatures from "../../../../public/features/aiforme/features-popup.json";
import ITSoftwarefeatures from "../../../../public/features/software/features-popup.json";

const TIME_CONSTANTS = {
  DAYS_IN_WEEK: 7,
  HOURS_IN_DAY: 24,
  MINUTES_IN_HOUR: 60,
  SECONDS_IN_MINUTE: 60,
  MILLISECONDS_IN_SECOND: 1000,
};

const WEEK_IN_MILLISECONDS =
  TIME_CONSTANTS.DAYS_IN_WEEK *
  TIME_CONSTANTS.HOURS_IN_DAY *
  TIME_CONSTANTS.MINUTES_IN_HOUR *
  TIME_CONSTANTS.SECONDS_IN_MINUTE *
  TIME_CONSTANTS.MILLISECONDS_IN_SECOND;

export enum FEATURE_TYPE {
  AIFORME = "aiforme",
  SOFTWARE = "software",
}
interface MediaItem {
  type: FeedbackMediaType;
  src: string;
  altText: string;
  style: any;
}

interface FeatureItem {
  titleText: string;
  media: MediaItem;
  bodyText: string | string[];
}

interface ModalWhatsNewProps {
  type?: FEATURE_TYPE;
}

const IMAGE_LIST: MediaItem[] = [
  {
    type: FeedbackMediaType.IMAGE,
    src: "/img/working-sitting.svg",
    altText: "person siting in desk",
    style: { padding: "16px" },
  },
  {
    type: FeedbackMediaType.IMAGE,
    src: "/img/team-high-five.svg",
    altText: "team high five",
    style: { padding: "16px" },
  },
  {
    type: FeedbackMediaType.IMAGE,
    src: "/img/character-on-bike.svg",
    altText: "person riding a bike",
    style: { padding: "16px" },
  },
];

const getDomain = (type: FEATURE_TYPE) => {
  switch (type) {
    case FEATURE_TYPE.SOFTWARE:
      return ITSoftwarefeatures;
    case FEATURE_TYPE.AIFORME:
      return AiForMefeatures;
    default:
      return AiForMefeatures;
  }
};

export const ModalWhatsNew: FC<ModalWhatsNewProps> = ({ type = FEATURE_TYPE.AIFORME }) => {
  const [popUpFeatures, setPopUpFeatures] = useState<FeatureItem[]>([]);
  const features = getDomain(type);

  useEffect(() => {
    const filteredFeatures = features
      .filter(
        (feature) =>
          !getCookie(`${COOKIE_NAMES.WHATS_NEW_DISMISSED}-${feature.title}`) &&
          new Date(feature.date) > new Date(new Date().getTime() - WEEK_IN_MILLISECONDS)
      )
      .map((feature, index) => ({
        media: IMAGE_LIST[index % IMAGE_LIST.length],
        titleText: feature.title,
        bodyText: feature.message,
      }));

    setPopUpFeatures(filteredFeatures);
  }, []);

  const handleClose = () => {
    popUpFeatures.forEach((feature) => {
      setCookie(`${COOKIE_NAMES.WHATS_NEW_DISMISSED}-${feature.titleText}`, "true");
    });
  };

  const { whatsNewModalProps } = useWhatsNewModal({
    isOpen: true,
    onClose: handleClose,
  });

  if (popUpFeatures.length === 0) {
    return null;
  }

  return <WhatsNewModal cards={popUpFeatures} {...whatsNewModalProps} />;
};
